// extracted by mini-css-extract-plugin
export default {"modal":"styles_modal__ZEC8e","ttl":"styles_ttl__g4eQV","txt":"styles_txt__ka0l7","btn":"styles_btn__JR1QH"};